export const sanitizeUrl = (url: string): string => {
	if (!url?.trim()) {
		return '';
	}

	try {
		const urlObject = /^https?:\/\//i.test(url)
			? new URL(url)
			: new URL(url, window?.location?.origin);

		if (!['http:', 'https:'].includes(urlObject.protocol)) {
			return '';
		}

		return urlObject
			.toString()
			.replace(/[^\w\s-.:/?#[\]@!$&'()*+,;=]/gi, '')
			.trim();
	} catch {
		return '';
	}
};
